<template>
    <rd-container size="large">
        <rd-header :title="$t('index.title', { totalCount : getTemplatesTotalCount })">
            <dx-button :use-submit-behavior="false"
                       type="default"
                       :text="$t('buttons.add')"
                       @click="function(){ $router.push({ name: 'processes.pzzConfirmationTemplates.add' }) }">
            </dx-button>
            <dx-button class="margin"
                       :use-submit-behavior="false"
                       type="default"
                       :text="$t('buttons.multipleClone')"
                       @click="onMultipleClone"
                       :disabled="!selectedRowKeys.length">
            </dx-button>
        </rd-header>

        <div class="row">
            <rd-column :size="$columns.TwelveOnLg">
                <dx-data-grid :data-source="getTemplatesDataSource"
                              :remote-operations="true"
                              :allow-column-resizing="true"
                              :column-auto-width="false"
                              :control-column-resizing="false"
                              :repaint-changes-only="true"
                              :selected-row-keys="selectedRowKeys"
                              @selection-changed="onSelectionChanged"
                              :allow-column-reordering="true"
                              :row-alternation-enabled="true"
                              :hover-state-enabled="true"
                              class="main-datagrid"
                              ref="gridData">
                    <dx-filter-row :visible="true"
                                   apply-filter="auto"
                                   :show-operation-chooser="false" />
                    <dx-column data-field="Name"
                               :caption="$t('index.captions.name')"
                               data-type="string"
                               cell-template="nameDetailsHyperlink" />
                    <dx-column data-field="DepartmentId"
                               :caption="$t('index.captions.department')">
                        <dx-lookup :data-source="getDepartments"
                                   display-expr="Text"
                                   value-expr="Value" />
                    </dx-column>
                    <dx-column data-field="OrderTypeId"
                               :caption="$t('index.captions.orderType')">
                        <dx-lookup :data-source="getOrderTypes"
                                   display-expr="Text"
                                   value-expr="Value" />
                    </dx-column>
                    <dx-column data-field="Id"
                               :allow-filtering="false"
                               :allow-reordering="false"
                               :allow-resizing="false"
                               alignment="center"
                               :width="175"
                               :caption="$t('index.captions.actions')"
                               cell-template="cellTemplate" />
                    <dx-column data-field="IsArchive"
                               :allow-filtering="true"
                               :allow-reordering="false"
                               :allow-resizing="false"
                               alignment="center"
                               data-type="boolean"
                               :filterValue="false"
                               :caption="$t('captions.visibility')"
                               cell-template="showOnFilterCellTemplate" />
                    <DxSelection select-all-mode="allPages"
                                 show-check-boxes-mode="always"
                                 mode="multiple" />
                    <dx-pager :allowed-page-sizes="pageSizes"
                              :show-page-size-selector="true" />
                    <dx-paging :page-size="30" />
                    <div slot="cellTemplate" slot-scope="{ data }">

                        <router-link :hint="$t('buttons.details')" :title="$t('buttons.details')" class="main-datagrid-btn"
                                     :to="{name: 'processes.pzzConfirmationTemplates.details', params: {id: data.value}}"><i class="fas fa-chevron-right"></i></router-link>
                        <span :hint="$t('buttons.edit')" :title="$t('buttons.edit')" class="main-datagrid-btn" @click="showEditPopup(data)"><i class="fas fa-pen"></i></span>
                        <span :hint="$t('buttons.delete')" :title="$t('buttons.delete')" class="main-datagrid-btn" @click="showDeletePopup(data)"><i class="fas fa-trash"></i></span>
                        <span :hint="$t('buttons.clone')" :title="$t('buttons.clone')" class="main-datagrid-btn" @click="cloneRecord(data.value)"><i class="fas fa-clone"></i></span>
                    </div>
                    <div slot="showOnFilterCellTemplate" slot-scope="{ data }">
                        <i @click="function(){ showVisibilityPopup(data); }" :title="data.data.IsArchive ? 'Zmień na widoczny': 'Zmień na niewidoczny'" class="large-icon main-datagrid-btn" :class="data.data.IsArchive ? 'fas fa-check-square': 'far fa-square'"></i>
                    </div>
                    <template #nameDetailsHyperlink="{ data }">
                        <router-link :hint="$t('buttons.details')"
                                     :title="$t('buttons.details')"
                                     style="color: #4099ff; text-decoration: underline; "
                                     :to="{name: 'processes.pzzConfirmationTemplates.details', params: {id: data.data.Id}}">{{ data.data.Name }}</router-link>
                    </template>
                    <dx-paging :page-size="30" />
                </dx-data-grid>

            </rd-column>
        </div>

        <dx-load-panel :visible="loadPanelConfig.visible"
                       :show-indicator="true"
                       :shading="true" />


        <rd-popup :visibility="deleteTemplateConfig.visible" :title="$t('index.deleteTemplate.title')">
            <rd-popup-content>
                <div class="row ">
                    <div class="col-xs-12 wrap">
                        <div v-if="deleteTemplateConfig.isUsed">{{getIsUsedContent}}</div>
                        <div v-else>{{getIsNotUsedContent}}</div>
                    </div>
                </div>
            </rd-popup-content>
            <rd-popup-actions>
                <dx-button :use-submit-behavior="false"
                           type="normal"
                           :text="$t('buttons.cancel')"
                           @click="closeDeleteTemplatePopup">
                </dx-button>
                <dx-button :use-submit-behavior="false"
                           type="danger"
                           class="ml-1"
                           @click="confirmDeleteTemplate"
                           :disabled="deleteTemplateConfig.isUsed"
                           :text="$t('buttons.delete')">
                </dx-button>
            </rd-popup-actions>
        </rd-popup>

        <rd-popup :visibility="visibilityTemplateConfig.visible" :title="$t('index.toggleVisibilityTitle')">
            <rd-popup-content>
            </rd-popup-content>
            <rd-popup-actions>
                <dx-button :use-submit-behavior="false"
                           type="normal"
                           :text="$t('buttons.cancel')"
                           @click="closeVisibilityTemplatePopup">
                </dx-button>
                <dx-button :use-submit-behavior="false"
                           type="default"
                           class="ml-1"
                           @click="confirmVisibilityTemplate"
                           :text="$t('buttons.yes')">
                </dx-button>
            </rd-popup-actions>
        </rd-popup>
        <!-- Edit -->
        <rd-popup :visibility="popupVisible" :title="$t('editTemplate.title')">
            <editForm @closeEdit="onEditPopupClose"></editForm>
        </rd-popup>

    </rd-container>
</template>
<script>
    // @ is an alias to /src
    import DxButton from 'devextreme-vue/button';
    import {
        DxDataGrid,
        DxColumn,
        DxFilterRow,
        DxLookup,
        DxSelection,
        DxPaging,
        DxPager
    } from 'devextreme-vue/data-grid';
    import { DxLoadPanel } from 'devextreme-vue/load-panel';

    import { mapFields } from 'vuex-map-fields';
    import { mapGetters, mapActions } from 'vuex';
    import commonMessages from '../../locales';
    import localMessages from '../locales';
    import editForm from './Edit';
    const name = "processesStores/pzzConfirmationTemplatesStores/indexStore";

    export default {
        name: 'templateList',
        created() {

        },
        data() {
            return {
                addBtnOptions: {
                    type: "default",
                    text: this.$t('buttons.add')
                },
                loadPanelConfig: {
                    visible: false
                },
                deleteTemplateConfig: {
                    templateId: null,
                    name: null,
                    isUsed: false,
                    visible: false,
                },
                visibilityTemplateConfig: {
                    templateId: null,
                    name: null,
                    visible: false,
                },
                pageSizes: [30, 50, 100],
                selectedRowKeys: [],
                popupVisible: false
            }
        },
        computed: {
            ...mapGetters(name, ['getTemplatesDataSource', 'getTemplatesTotalCount', 'getDepartments', 'getOrderTypes']),
            ...mapFields(name, []),
            getIsUsedContent() {
                return this.$t('index.deleteTemplate.isUsedContent', { name: this.deleteTemplateConfig.name });
            },
            getIsNotUsedContent() {
                return this.$t('index.deleteTemplate.isNotUsedContent', { name: this.deleteTemplateConfig.name });
            },
        },
        methods: {
            ...mapActions(name, ['setRolesList', 'setLoaded', 'setTemplatesTotalCount', 'getData', 'isTemplateUsed', 'toggleVisibility', 'deleteTemplate', 'cloneTemplate', 'cloneTemplates', 'editTemplate', 'setDetails', 'setId']),
            showDeletePopup(options) {
                this.deleteTemplateConfig.id = options.data.Id;
                this.deleteTemplateConfig.name = options.data.Name;
                this.loadPanelConfig.visible = true;
                this.isTemplateUsed(options.data.Id).then(response => {
                    this.deleteTemplateConfig.isUsed = response.data;
                    this.loadPanelConfig.visible = false;
                    this.deleteTemplateConfig.visible = true;
                });
            },
            showVisibilityPopup(options) {
                this.visibilityTemplateConfig.id = options.data.Id;
                this.visibilityTemplateConfig.name = options.data.Name;
                this.visibilityTemplateConfig.visible = true;

            },
            onMultipleClone() {
                this.cloneTemplates(this.selectedRowKeys).then(() => {
                    this.$refs['gridData'].instance.refresh();
                });
                this.clearSelection();
            },
            onSelectionChanged({ selectedRowKeys }) {
                this.selectedRowKeys = selectedRowKeys;
            },
            closeDeleteTemplatePopup: function () {
                this.deleteTemplateConfig.visible = false;
            },
            closeVisibilityTemplatePopup: function () {
                this.visibilityTemplateConfig.visible = false;
            },
            confirmDeleteTemplate: function () {
                this.loadPanelConfig.visible = true;
                this.deleteTemplate(this.deleteTemplateConfig.id).then(() => {
                    this.deleteTemplateConfig.visible = false;
                    this.loadPanelConfig.visible = false;
                    this.$refs['gridData'].instance.refresh();
                })
            },
            confirmVisibilityTemplate: function () {
                this.visibilityTemplateConfig.visible = false;
                this.toggleVisibility(this.visibilityTemplateConfig.id)     
            },
            cloneRecord(id) {
                this.cloneTemplate(id).then(() => {
                    this.$refs['gridData'].instance.refresh();
                    this.$refs["gridData"].instance.clearSelection();
                });
            },
            clearSelection() {
                const dataGrid = this.$refs["gridData"].instance;
                dataGrid.clearSelection();
            },
            showEditPopup(data) {
                this.setId(data.value);
                this.setDetails(data);
                this.popupVisible = true;
            },
            onEditPopupClose() {
                this.popupVisible = false;
            }
        },
        mounted() {
            var gridInstance = this.$refs.gridData.instance;
            var setTemplatesTotalCount = this.setTemplatesTotalCount;
            this.setLoaded(() => {
                setTemplatesTotalCount(gridInstance.totalCount());
            });
            this.getData();


        },
        components: {
            DxDataGrid,
            DxColumn,
            DxFilterRow,
            DxLookup,
            DxPaging,
            DxPager,
            DxButton,
            DxLoadPanel,
            DxSelection,
            editForm            
        },
        i18n: {
            messages: localMessages.messages,
            sharedMessages: commonMessages.messages
        }
    }
</script>
<style scoped>
    .margin {
        margin-left: 5px;
    }

    .large-icon {
        font-size: 120%;
    }

    .wrap {
        overflow-wrap: break-word;
    }
</style>